"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.998 1a11.0006 11.0006 0 1 0 .0053 22.0012A11.0006 11.0006 0 0 0 11.998 1zm5.0439 15.8659a.6846.6846 0 0 1-.4241.3098.6853.6853 0 0 1-.519-.0812c-2.5823-1.5763-5.8333-1.9362-9.6622-1.0614a.685.685 0 0 1-.732-.2603.686.686 0 0 1 .1731-.9714.6866.6866 0 0 1 .2529-.1041c4.1901-.9589 7.7852-.5464 10.6841 1.2255a.6857.6857 0 0 1 .2312.9431h-.004zm1.3464-2.9948a.8603.8603 0 0 1-.5326.3862.8596.8596 0 0 1-.6496-.1038c-2.9567-1.8179-7.4634-2.3433-10.9613-1.282a.8587.8587 0 0 1-.6533-.0644.858.858 0 0 1 .1555-1.5775c3.9944-1.211 8.9608-.6239 12.3562 1.462a.8588.8588 0 0 1 .289 1.1795h-.0039zm.1156-3.1196C14.9574 8.6499 9.1096 8.4529 5.7247 9.48a1.0293 1.0293 0 1 1-.5963-1.9702c3.8853-1.1822 10.3439-.9523 14.4263 1.471a1.0293 1.0293 0 0 1 .4929 1.0316 1.0286 1.0286 0 0 1-1.1652.8715 1.0286 1.0286 0 0 1-.3785-.1337v.0013z",
    fill: "#1ED760"
  })];
};

exports.default = _default;